import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useToastStore } from "@/stores/useToastStore";

interface OrganizationSwitcher {
  switchOrganization: (
    organizationId: string,
  ) => Promise<{ destination: string | null } | undefined>;
}

export function useShellOrganizationSwitch({ switchOrganization }: OrganizationSwitcher) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const showToast = useToastStore((state) => state.showToast);

  return async (organizationId: string) => {
    const result = await switchOrganization(organizationId);
    if (!result) {
      showToast(t("organization.switch_failed"), "error");
      return;
    }
    if (result.destination) navigate(result.destination, { replace: true });
  };
}
